import { Component, inject, OnInit, signal } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ActivatedRoute } from "@angular/router";

import { VideoService } from "../../../shared/services/video.service";
import { ModalService } from "../../../shared/services/modal.service";
import { ExternalpageSingle } from "../../../class/externalpage-single";
import { TestimonialService } from "../../../shared/services/testimonial.service";

@Component({
  selector: "app-page-video",
  templateUrl: "./page-video.component.html",
  styleUrls: ["./page-video.component.scss"],
  standalone: false,
})
export class PageVideoComponent extends ExternalpageSingle implements OnInit {
  readonly videoService = inject(VideoService);
  private readonly route = inject(ActivatedRoute);
  readonly modal = inject(ModalService);
  private readonly testimonialService = inject(TestimonialService);

  testimonialSlides = signal<any[]>([]);
  public relatedData = signal<any[]>([]);

  constructor() {
    super();
    this.videoService.setHomeData();
    this.testimonialService.setHomeData();
  }

  ngOnInit(): void {
    // Only load data if entity hasn't been provided by parent (dynamic component loading)
    if (!this.entity || !this.entity.id) {
      this.route.params
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((routeParams) => {
          this.onIdChange();
          this.loadSingle(routeParams["id"]);
        });
    } else {
      // Entity data provided by parent component, just run callbacks
      this.parseImages();
      this.loadCallback();
      this.setMetaTags();
    }

    const existingTestimonials = this.testimonialService.homeData;
    if (existingTestimonials.length > 0) {
      this.testimonialSlides.set(existingTestimonials);
    } else {
      this.testimonialService.$homeDataSubject
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => {
          this.testimonialSlides.set(this.testimonialService.homeData);
        });
    }
  }

  override loadCallback(): void {
    this.setRelatedData(this.entity.id);
  }

  setRelatedData(id: string | null): void {
    this.relatedData.set([]);
    const tmp = this.videoService.homeData;
    if (tmp.length === 0) {
      this.videoService.$homeDataSubject
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => {
          const items: any[] = [];
          for (const item of this.videoService.homeData) {
            if (item["id"] !== id && items.length < this.maxRelatedDataItems) {
              items.push(item);
            }
          }
          this.relatedData.set(items);
        });
    } else {
      const items: any[] = [];
      for (const item of tmp) {
        if (item["id"] !== id && items.length < this.maxRelatedDataItems) {
          items.push(item);
        }
      }
      this.relatedData.set(items);
    }
  }
}

export interface SingleVideo {
  id: "";
  title: "";
  content: "";
  imageUri: "";
  images: any;
}
